export default __webpack_public_path__ + "static/media/firing-range.63bc4efd.jpg";